import React from 'react';
import PropTypes from 'prop-types';

// Helper function to retrieve the display name for the key
const getDisplayName = (key) => {
  const map = {
    coolingFlow: 'Cooling Flow',
    emuDepth: 'EMU Depth',
    eventType: 'Event Type',
    returnGasFlowScfm: 'Return Gas Flow (SCFM)',
    suitActualPressure: 'Suit Actual Pressure',
    suitAmbientPressure: 'Suit Ambient Pressure',
    suitDeltaPressure: 'Suit Delta Pressure',
    supplyGasFlowScfm: 'Supply Gas Flow (SCFM)',
    testStartTime: 'Test Start Time',
    timestamp: 'Timestamp',
    totalGasOnTimeInSec: 'Total Gas On Time (sec)',
    umbilicalColor: 'Umbilical Color',
    waterSupplyTemp: 'Water Supply Temp',
  };
  return map[key] || key;
};

const EcsSuitTooltip = ({ active, payload, activeKeys }) => {
  if (!active || !payload) {
    return null;
  }
  const [firstPayload] = payload;
  const { payload: data } = firstPayload;

  return (
    <ul className="custom-tooltip">
      {Object.keys(data).sort().map((key) => {
        if (activeKeys[key]) {
          return (
            <li className="label" key={key}>
              {`${getDisplayName(key)}: ${data[key]}`}
            </li>
          );
        }
        return null;
      })}
    </ul>
  );
};

EcsSuitTooltip.propTypes = {
  active: PropTypes.bool,
  payload: PropTypes.arrayOf(PropTypes.object),
  activeKeys: PropTypes.objectOf(PropTypes.bool),
};

export default EcsSuitTooltip;
